import { BaseComponentConfig, BaseComponentModel, ContentType } from '@models';
import { BaseComponent } from '../../base.component';

export abstract class BaseContentComponent<
    TConfig extends BaseComponentConfig,
    TData extends ContentType,
    TModel extends BaseComponentModel
> extends BaseComponent<TConfig, TData, TModel> {
    protected override bindFromEvent = false;
}
